import { useForm as useBaseForm } from 'react-hook-form';
import { vestResolver } from '@hookform/resolvers/vest';

const useForm = ({ suite, ...other } = {}) => {
  const form = useBaseForm({
    ...other,
    resolver: suite ? vestResolver(suite) : undefined
  });

  return {
    ...form,
    register: (name, options = undefined) => ({
      ...form.register(name, options),
      invalid: !!form.formState.errors[name],
      invalidText: form.formState.errors[name]?.message
    })
  };
};

export default useForm;
